import { useState } from 'react'
import { useUpdateProject } from '../api/queries'
import type { Project } from '../api/types'

/**
 * Arkivér eller gendan sagen (beslutning 090).
 *
 * Serveren havde arkiveringen i `PUT /api/projects/{id}` (IsArchived) og skriver den i
 * aktivitetsloggen, men der var ingen knap - og sletningen bad folk om at arkivere i
 * stedet. Samme regel som serverens CanEditProject: Superadmin, Administrator og
 * Projektleder. Sagen bliver stående med alt indhold og kan findes under "Vis arkiv".
 */
export function ArchiveProjectButton({ project }: { project: Project }) {
  const update = useUpdateProject(project.id)
  const [error, setError] = useState<string | null>(null)

  async function toggle() {
    const archive = !project.isArchived
    const message = archive
      ? `Arkivér sagen "${project.name}"?\n\nDen forsvinder fra sagslisten, men intet slettes. ` +
        'Den kan findes under "Vis arkiv" og gendannes igen.'
      : `Gendan sagen "${project.name}" fra arkivet?`

    if (!window.confirm(message)) return

    setError(null)
    try {
      await update.mutateAsync({ isArchived: archive })
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sagen kunne ikke ændres.')
    }
  }

  return (
    <>
      <button className="btn btn--sm" disabled={update.isPending} onClick={() => void toggle()}>
        {update.isPending ? 'Gemmer ...' : project.isArchived ? 'Gendan fra arkiv' : 'Arkivér'}
      </button>
      {error && <div className="tiny overdue">{error}</div>}
    </>
  )
}
